import * as R from "ramda";

export const getItemsForPage = (data, page, pageSize) => {
  const start = (page - 1) * pageSize;
  const end = start + pageSize;

  return R.slice(start, end, data);
};

export const objFromListWith = R.curry((fn, list) =>
  R.chain(R.zipObj, R.map(fn))(list)
);

export const listHasItems = R.compose(
  Boolean,
  R.length
);
